import { useMemo } from "react";
import BouncingDotsLoader from "./BouncingDotsLoader";
import pfp from "./pfp";

const renderIsTyping = (img, name) => {
  return (
    <>
      <div className="fw-700 fs-14 lh-196 d-flex align-items-center">
        {img}
        <div className="truncate-name">{name}</div>
        <div style={{ marginLeft: "0.25em" }}>is typing</div>
      </div>
      <div
        className="d-flex align-items-center"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
        }}
      >
        <BouncingDotsLoader />
      </div>
    </>
  );
};

const renderBothTyping = (userInfo, props) => {
  return (
    <>
      <div className="fw-700 fs-14 lh-196 d-flex align-items-center">
        {pfp(userInfo?.pfp, 20, true)}
        {pfp(props?.openedChannel?.icon, 20, true)}
        <div className="truncate-name">{userInfo?.firstName},</div>
        <div style={{ marginLeft: "0.25em" }} className="truncate-name">
          {props?.openedChannel?.title},
        </div>
        <div style={{ marginLeft: "0.25em" }}>are typing</div>
      </div>
      <div
        className="d-flex align-items-center"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
        }}
      >
        <BouncingDotsLoader />
      </div>
    </>
  );
};

const TypingIndicator = ({
  userInfo,
  props = null,
  userIsTyping = false,
  otherIsTyping = false,
  chatBarHeight = 0,
  replyToPadding = 0,
}) => {
  const userTypingIndicator = useMemo(
    () =>
      props
        ? renderIsTyping(pfp(userInfo?.pfp, 20, true), userInfo?.firstName)
        : null,
    [userInfo],
  );

  const otherTypingIndicator = useMemo(
    () =>
      props
        ? renderIsTyping(
            pfp(props?.openedChannel?.icon, 20, true),
            props?.openedChannel?.title,
          )
        : null,
    [props?.openedChannel],
  );

  const bothTypingIndicator = useMemo(
    () => (props ? renderBothTyping(userInfo, props) : null),
    [userInfo, props],
  );

  return (
    <div
      className="p-0"
      style={{
        height: "50px",
        marginLeft: "0px",
        pointerEvents: "none",
      }}
    >
      {(userIsTyping || otherIsTyping) && (
        <div
          className="align-items-center"
          style={{
            display: "inline-flex",
            pointerEvents: "none",
            background: "white",
            borderRadius: "16px",
            height: "50px",
            transform: `translateY(${
              -(chatBarHeight + replyToPadding) + 152 - 32
            }px)`,
            transition: "transform 0.3s",
          }}
        >
          {userIsTyping && !otherIsTyping && userTypingIndicator}
          {otherIsTyping && !userIsTyping && otherTypingIndicator}
          {userIsTyping && otherIsTyping && bothTypingIndicator}
        </div>
      )}
    </div>
  );
};

export default TypingIndicator;
